import React, { useState, useMemo } from 'react';
import AsyncSelect from 'react-select/async'
import restClient from 'hooks/restClient'

const SchoolQuestion = ({ onSubmit }) => {
  const [selected, setSelected] = useState(null)

  const loadOptions = useMemo(() => {
    function load(text, callback) {
      restClient.get('/api/organisations/search', { params: { query: text, kind: 'school' } })
        .then(({ data }) => callback(data))
    }
    return _.debounce(load, 300)
  }, [])

  function handleSubmit(e) {
    e.preventDefault()
    if (selected) {
      onSubmit(selected.label)
    }
  }

  // Show the school name, with its address greyed below it in the menu to help
  // disambiguate similarly-named schools. The selected value shows just the name.
  function formatOptionLabel(option, { context }) {
    const name = option.name || option.label
    if (context === 'value') {
      return name
    }
    return (
      <div>
        <div>{name}</div>
        {option.address && (
          <div style={{ fontSize: '0.85em', color: '#8792A2' }}>{option.address}</div>
        )}
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit}>
      <AsyncSelect
        cacheOptions
        classNamePrefix="react-select"
        loadOptions={loadOptions}
        formatOptionLabel={formatOptionLabel}
        onChange={setSelected}
        value={selected}
        placeholder="Start typing to search for your school"
        noOptionsMessage={() => "Start typing to search"}
      />
      <button className='button primary margin-top' disabled={!selected}>Next</button>
    </form>
  )
}

export default SchoolQuestion;
